import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import { PayrollSlice } from './Slices/PayrollSlice';
import { AttendanceSlice } from './Slices/AttendanceSlice';
import { TeamAttendanceSlice } from './Slices/TeamAttendanceSlice'
import { ProcessPayrollSlice } from './Slices/ProcessPayrollSlice';
import { EmployeeSlice } from './Slices/EmployeeListSlice';
import { ComponentSlice } from './Slices/ComponentListSlice';
import { EmployeeTaxSlice } from './Slices/EmployeeTaxSlice';
import { BenefitSlice } from './Slices/BenefitSlice';
import { CustomFieldSlice } from './Slices/CustomFieldsSlice';
import { PayrollLiabilityReportSlice } from './Slices/PayrollLiabilityReportSlice';
import { ContractorSlice } from './Slices/ContractorSlice';
import { ContractorPayrollSlice } from './Slices/ContractorPayrollSlice';

import { ComponentGroupsSlice } from './Slices/ComponentGroupsSlice';
import { SyncJEToBooksSlice } from './Slices/SyncJEToBooksSlice';
import { ImportLogSlice } from './Slices/ImportLogSlice';
import { ExpenseIntegrationSlice } from './Slices/ExpenseIntegartionSlice';
import { ExpenseClaimListSlice } from './Slices/ExpenseClaimListSlice';

import {ExpenseGroupSlice} from './Slices/ExpenseGroupSlice';
import { ExpenseCategoriesSlice } from './Slices/ExpenseCategorySlice';
import { LocationListSlice } from './Slices/LocationListSlice';
import { StatutoryReportSlice } from './Slices/StatutoryReportSlice';
import {CustomNumberFormatSlice} from './Slices/CustomNumberFormat';
import { IRASSettingsSlice } from './Slices/IRASSettingsSlice';
import { AISSubmissionSlice } from './Slices/AISSubmissionSlice';
import { SGFormsSlice } from './Slices/SGFormsSlice';
import { ShiftManagementSlice } from './Slices/ShiftManagementSlice';
import { CompOffSlice } from './Slices/CompOffSlice';
import { BiometricSlice } from './Slices/BiometricSlice';
import { TeamAttendanceDashbaordSlice } from './Slices/TeamAttendanceDashboardSlice';
import { BooksContactSlice } from './Slices/BooksContactSlice';
import { ProjectSlice } from './Slices/ProjectSlice';
import { TaskSlice } from './Slices/TaskSlice';
import { EmployeeMappingSlice } from './Slices/EmployeeMappingSlice';
import userPrefSlice from './Slices/userPrefSlice';
import { ExpenseLimit } from './Slices/ExpenseLimitSlice';
import { ModuleAccessControlSlice } from './Slices/ModuleAccessControlSlice';
import { PolicyAndResourcesSlice } from './Slices/PolicyAndResourcesSlice';

export const Store = configureStore({
  reducer: {
    payroll: PayrollSlice.reducer,
    attendance: AttendanceSlice.reducer,
    teamAttendance: TeamAttendanceSlice.reducer,
    processPayroll: ProcessPayrollSlice.reducer,
    employee: EmployeeSlice.reducer,
    component: ComponentSlice.reducer,
    employeeTAX: EmployeeTaxSlice.reducer,
    benefit: BenefitSlice.reducer,
    customField: CustomFieldSlice.reducer,
    payrollLiabilityReport: PayrollLiabilityReportSlice.reducer,
    contractor: ContractorSlice.reducer,
    contractorPayroll: ContractorPayrollSlice.reducer,
    syncRevertJEGrid: SyncJEToBooksSlice.reducer,
    componentGroups: ComponentGroupsSlice.reducer,
    importLog: ImportLogSlice.reducer,
    expenseIntegration: ExpenseIntegrationSlice.reducer,
    expenseGroup: ExpenseGroupSlice.reducer,
    expenseCategories: ExpenseCategoriesSlice.reducer,
    expenses: ExpenseClaimListSlice.reducer,
    locationList: LocationListSlice.reducer,
    statutoryReport: StatutoryReportSlice.reducer,
    customNumberFormat: CustomNumberFormatSlice.reducer,
    irasSettings: IRASSettingsSlice.reducer,
    aisSubmission: AISSubmissionSlice.reducer,
    sgForms: SGFormsSlice.reducer,
    shifts: ShiftManagementSlice.reducer,
    compOff: CompOffSlice.reducer,
    biometricAttendance: BiometricSlice.reducer,
    teamAttendanceDashbaord: TeamAttendanceDashbaordSlice.reducer,
    booksContact: BooksContactSlice.reducer,
    project: ProjectSlice.reducer,
    task: TaskSlice.reducer,
    employeeMapping: EmployeeMappingSlice.reducer,
    userPref: userPrefSlice,
    expenseLimit: ExpenseLimit.reducer,
    moduleAccessControl: ModuleAccessControlSlice.reducer,
    policyAndResources: PolicyAndResourcesSlice.reducer
  },
});
